import { BaseParser, IValidateParams } from './BaseParser';
import { ValueType, ParseResult, IParseResult } from '../FormatterTypes';
import {
  formatterStrParamDef,
  formatterBoolParamDef,
} from '../Utils/ParamUtils';
import luhn from 'luhn';

const numbers = '0123456789';
class TEDParseOrgNr extends BaseParser {
  public static getInstance(): TEDParseOrgNr {
    return this.instance ? this.instance : (this.instance = new this());
  }

  private static instance: TEDParseOrgNr;

  defaultParams(): string {
    return 'ValidONSeps="-/ ,.";AllowForeign="Y"';
  }

  getValidateParams(params: string): IValidateParams {
    const validONSeps = formatterStrParamDef(
      'ValidONSeps',
      params,
      this.defaultParams()
    );

    return { inputsList: numbers, separators: validONSeps };
  }

  parse(text: string, params: string = ''): IParseResult {
    let result = ParseResult.OK;
    let value: ValueType = null;

    if (text !== '') {
      const validSeps = formatterStrParamDef(
        'ValidONSeps',
        params,
        this.defaultParams()
      );
      let regEx = new RegExp(`^(\\d{6})?[${validSeps}]?(\\d{4})$`);
      const regExResult = regEx.exec(text);
      if (regExResult && regExResult[0] && regExResult[1] && regExResult[2]) {
        if (luhn.validate(regExResult[1] + regExResult[2])) {
          value = regExResult[1] + regExResult[2];
        } else {
          result = ParseResult.ERROR_ON_ORGINVALIDCONTROLDIGIT;
        }
      } else if (
        formatterBoolParamDef('AllowForeign', params, this.defaultParams())
      ) {
        value = text;
      }
    }

    return { result, value };
  }
}

export { TEDParseOrgNr };
